<script>
  import { intcomma } from 'journalize';
  import { raf } from 'svelte/internal';
  import { formatPercent } from '../utils/format.js';
  import Photos from './Photos.svelte';

  /** @type {string} */
  export let candidateGivenName;
  /** @type {string} */
  export let candidateFamilyName;
  /** @type {number} */
  export let candidateVotes;
  /** @type {number} */
  export let totalVotes;
  /** @type {boolean} */
  export let isIncumbent;
  /** @type {boolean} */
  export let isWinner;
  /** @type {string} */
  export let candidateParty;
  /** @type {string} */
  export let raceID;

  /** @type {import('../types.d').Crosswalk} */
  export let lookup;

  $: barPercent = formatPercent(candidateVotes, totalVotes);

  $: name = `${candidateGivenName} ${candidateFamilyName}`;
  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }
</script>

<td class="candidate__cell">
  <div class="candidate-headshot {slugify(name)}">
    <Photos
      {name}
      img={lookup.img}
      avif={lookup.avif}
      webp={lookup.webp}
      party={candidateParty}
    />
  </div>
</td>
<th scope="row" class="candidate__cell candidate__cell-name">
  <span class="candidate__cell-checkmark candidate__{candidateParty}"> {isWinner ? `✓` : ''}</span>
  <div class="{isWinner ? 'text-medium' : ''}">
    {#if candidateGivenName}<span class="desktop-only"
        >{candidateGivenName}</span
      >{/if}

    <span class="breakpoint"
      >{candidateFamilyName}
      {#if isIncumbent}
        <span
          class="candidate__cell-incumbent"
          title="Currently holds this office"
          role="img"
          aria-label="incumbent">*</span
        >
      {/if}
    </span>
  </div>

  <!-- {#if isRunoff}
  <span
    class="candidate__cell-runoff candidate__{partyFlag}">
    Runoff
    </span>
  {/if} -->
</th>

<td class="candidate__cell bar-chart {raceID}" aria-hidden="true">
  <div class="bar-container {raceID}">
    <div
      class="inner-bar {candidateParty} {raceID}"
      style="width:{barPercent}%"
    />
  </div>
</td>
<td
  class="candidate__cell candidate__cell-pct {isWinner ? 'text-medium' : ''} text-right"
  aria-label="{formatPercent(candidateVotes, totalVotes)}%"
>
  {formatPercent(candidateVotes, totalVotes)}
  <span class="candidate__pct-symbol">%</span>
</td>
